export enum RopType {
	CSS2D = 'CSS2DRenderer',
	CSS3D = 'CSS3DRenderer',
	WEBGL = 'WebGLRenderer',
	WEBGPU = 'WebGPURenderer',
	PATH_TRACING = 'pathTracingRenderer',
}
